// Página Dwight (config) — orquestra as abas do agente: skills, configuração,
// memória, diagnóstico, exemplos de redação, backlog e pareamento Telegram.
// Entry point fino; conteúdo de cada aba vive em src/pages/hydra-config/.
import { useEffect, useState } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';
import { Tabs, Typography, Space, App as AntApp, Flex } from 'antd';
import {
  ToolOutlined, ApiOutlined, MedicineBoxOutlined, BulbOutlined,
  BookOutlined, FileTextOutlined, MobileOutlined, ExperimentOutlined,
} from '@ant-design/icons';
import IconDwight from '../components/IconDwight';
import ConfigTab from './hydra-config/ConfigTab';
import SkillsTab from './hydra-config/SkillsTab';
import DiagnosticoTab from './hydra-config/DiagnosticoTab';
import MemoriaTab from './hydra-config/MemoriaTab';
import ExemplosTab from './hydra-config/ExemplosTab';
import BacklogTab from './hydra-config/BacklogTab';
import TelegramTab from './hydra-config/TelegramTab';
import PilotoOpusTab from './hydra-config/PilotoOpusTab';

const { Title, Text } = Typography;

function DwightConfigInner() {
  const [aba, setAba] = useState<'config' | 'skills' | 'diagnostico' | 'memoria' | 'backlog' | 'exemplos' | 'telegram' | 'piloto'>('config');
  const [admin, setAdmin] = useState(false);
  useEffect(() => {
    let ativo = true;
    fetchAuthSession().then(session => {
      const grupos = session.tokens?.idToken?.payload['cognito:groups'];
      if (ativo) setAdmin(Array.isArray(grupos) && grupos.includes('admin'));
    }).catch(() => { if (ativo) setAdmin(false); });
    return () => { ativo = false; };
  }, []);
  return (
    <div style={{ padding: '16px 24px', maxWidth: ['piloto', 'diagnostico'].includes(aba) ? undefined : 1200, margin: '0 auto' }}>
      <Flex align="center" gap={14} style={{ marginBottom: 14 }}>
        <span style={{ color: '#020D7F' }}><IconDwight size={32} /></span>
        <div>
          <Title level={4} style={{ margin: 0, color: '#020D7F' }}>Dwight — auto-aprimoramento</Title>
          <Text type="secondary" style={{ fontSize: 11 }}>
            Skills, configuração, memória, diagnóstico e backlog de melhorias
          </Text>
        </div>
      </Flex>

      <Tabs
        activeKey={aba} onChange={(k) => setAba(k as any)} size="small"
        items={[
          { key: 'config',      label: <Space size={4}><ToolOutlined /> Configuração</Space>, children: <ConfigTab /> },
          { key: 'skills',      label: <Space size={4}><ApiOutlined /> Skills</Space>, children: <SkillsTab /> },
          { key: 'diagnostico', label: <Space size={4}><MedicineBoxOutlined /> Diagnóstico</Space>, children: <DiagnosticoTab /> },
          { key: 'memoria',     label: <Space size={4}><BulbOutlined /> Memória</Space>, children: <MemoriaTab /> },
          { key: 'exemplos',    label: <Space size={4}><BookOutlined /> Exemplos de redação</Space>, children: <ExemplosTab /> },
          { key: 'backlog',     label: <Space size={4}><FileTextOutlined /> Backlog</Space>, children: <BacklogTab /> },
          { key: 'telegram',    label: <Space size={4}><MobileOutlined /> Telegram</Space>, children: <TelegramTab /> },
          ...(admin ? [{ key: 'piloto', label: <Space size={4}><ExperimentOutlined /> Piloto Opus 4.7</Space>, children: <PilotoOpusTab /> }] : []),
        ]}
      />
    </div>
  );
}

export default function DwightConfig() {
  return (
    <AntApp>
      <DwightConfigInner />
    </AntApp>
  );
}
